module.exports = __webpack_public_path__ + "img/tabMessage.e3d558ee.svg";